import React from "react";
import { useIntl, defineMessages, FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import { Modal } from "../modal/Modal";
import { CloseButton } from "../input/CloseButton";
import { Button } from "../input/Button";
import { Column } from "../layout/Column";

export function OpenPopupModal({ onClose, popup_title, popup_content }) {
  const intl = useIntl();

  return (
    <Modal title={popup_title} beforeTitle={<CloseButton onClick={onClose} />}>
      <Column padding center centerMd="both" grow>
        <div className="ck-content" dangerouslySetInnerHTML={{ __html: popup_content }}></div>
      </Column>
    </Modal>
  );
}

OpenPopupModal.propTypes = {
  onClose: PropTypes.func
};
